import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { GroupsPage } from './pages/GroupsPage';
import { GroupDetailsPage } from './pages/GroupDetailsPage';
import { TabsPage } from './pages/TabsPage';
import { TabDetailsPage } from './pages/TabDetailsPage';
import { JoinTabByLink } from './pages/JoinTabByLink';
import { SettingsPage } from './pages/SettingsPage';
import { FriendsPage } from './pages/FriendsPage';
import { MagicLinkHandler } from './pages/MagicLinkHandler';

import { DevTools } from './components/DevTools';
import { PwaUpdater } from './components/PwaUpdater';

const ConfigCheck: React.FC = () => {
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;
  const useEmulators = import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';

  if (!useEmulators && (!apiKey || apiKey === 'your_api_key' || apiKey === 'PROD_API_KEY')) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-red-50 p-4">
        <div className="max-w-md space-y-4 rounded-xl bg-white p-6 shadow-xl border border-red-200">
          <h2 className="text-xl font-bold text-red-600">Configuration Error</h2>
          <p className="text-sm text-slate-600">
            The application is missing valid Firebase credentials.
          </p>
          <ul className="list-disc pl-5 text-xs text-slate-500 space-y-1">
            <li>VITE_USE_FIREBASE_EMULATORS is false</li>
            <li>VITE_FIREBASE_API_KEY is missing or default</li>
          </ul>
          <div className="rounded bg-slate-100 p-2 text-[10px] font-mono">
            Key Present: {apiKey ? 'Yes (Invalid)' : 'No'}
          </div>
          <p className="text-xs font-bold text-slate-800">
            Action Required: Add VITE_FIREBASE_... secrets to your GitHub Repository Settings and redeploy, or enable Emulators for local development.
          </p>
        </div>
      </div>
    );
  }
  return null;
};

function App() {
  return (
    <Router>
      <ConfigCheck />
      <DevTools />
      <PwaUpdater />
      <Layout>
        <Routes>
          <Route path="/" element={<TabsPage />} />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/group/:id" element={<GroupDetailsPage />} />
          <Route path="/tabs" element={<TabsPage />} />
          <Route path="/tab/:id" element={<TabDetailsPage />} />
          <Route path="/join/:tabId" element={<JoinTabByLink />} />
          <Route path="/friends" element={<FriendsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/auth/magic-link" element={<MagicLinkHandler />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
